import HeroSectionComponent from './HeroSectionComponent';

/**
 * @typedef {import("@prismicio/client").Content.HeroSectionSlice} HeroSectionSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroSectionSlice>} HeroSectionProps
 * @param { HeroSectionProps }
 */
const HeroSection = ({ slice, context }) => {
  const { pageType } = context || {};
  return (
    <section>
      <HeroSectionComponent slice={slice} pageType={pageType} />
    </section>
  );
};

export default HeroSection;
